import { EventHandlerBase, Pointer, Primitive } from "pytha2";
import { Line } from "tnbase";

/**
 * 生成轴线特殊处理器
 */
export class EventHandlerGenAxisLine extends EventHandlerBase {

    /**
     * 生成线图元的type 轴线为AxisLine
     */
    lineType: string = "AxisLine";

    /**
     * 处理器默认运行入口
     * @param data 
     * @returns 
     */
    run(data = {}) {
        console.log("EHGenAxisLine run")
        const storage = this.getPythaStorage();
        //获取当前点
        const pointerDownList = this.node.graph.cache.pointerDownList;
        if (pointerDownList.length < 1) return false;

        //新建图元
        let primitive = new Primitive(this.lineType);
        //根据坐标点新建几何线
        let pointer: Pointer = pointerDownList[pointerDownList.length - 1];
        let end = storage.coordinateStore.currentPos;
        if (storage.orthoPolarStore.orthoPolarPoint) {
            end = storage.orthoPolarStore.orthoPolarPoint;
        }
        let line = new Line(pointer.point, end);
        //将图元与几何线绑定
        primitive.temporary = true;
        primitive.geos.push(line);
        let keys = Object.keys(primitive.renderItemDict);
        if (keys.length > 0) {
            let renderItem = primitive.renderItemDict[keys[0]];
            renderItem.geoElements = line.getGeoElementsIdxList();
            renderItem.mat?.color.set(storage.layerStore.getColor());
            // renderItem.mat.color.set(0xE54242);
        }
        primitive.layerUuid = storage.layerStore.currentLayerUuid || null;
        primitive.colorByLayer = true;
        //将线存入图的缓存区
        this.node.graph.cache['line'] = line; // geo 放入缓存 方便计算调用
        this.node.graph.cache['primitive'] = primitive;
        this.node.graph.cache.data['isPointDown'] = false;
        //将线存入临时图元中
        storage.primitiveStore.tempPrimitiveDict[primitive.uuid] = primitive;
        this.node.graph.cache.primitiveList = [primitive]
        return true;
    }
}